import { useId } from 'react'
import type { ReactNode } from 'react'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import './Checkbox.css'

export interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  children: ReactNode
  /** Casilla de 24 px con radio 6; `tone` success cuando marca algo hecho (lista de comprobación) */
  tone?: 'primary' | 'success'
  /** Texto en tamaño h3 (filas de la lista de comprobación) */
  large?: boolean
  disabled?: boolean
  id?: string
  name?: string
  className?: string
}

/** Casilla integrada en el flujo (consentimientos) y filas de la lista de comprobación (bundle B7). */
export function Checkbox({ checked, onChange, children, tone = 'primary', large, disabled, id, name, className }: CheckboxProps) {
  const uid = useId()
  const inputId = id ?? `hp-check-${uid}`
  return (
    <label htmlFor={inputId} className={cx('hp-check', `hp-check--${tone}`, checked && 'hp-check--on', large && 'hp-check--large', disabled && 'hp-check--disabled', className)}>
      <input id={inputId} name={name} type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} className="hp-check__input" />
      <span className="hp-check__box" aria-hidden="true">
        {checked && <Icon name="check" size={16} strokeWidth={3} />}
      </span>
      <span className="hp-check__label">{children}</span>
    </label>
  )
}
